import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrls } from 'src/app/services/ApiUrls';
// import { grievanceServerUrl } from '../../../grievenceServerUrl';

@Injectable({
  providedIn: 'root'
})
export class ObjectionSuggestionTypeService {

  constructor(public httpClient:HttpClient) { }


   //submit rest
   async submitObjectionSuggestionType(data: any) {
  
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.createObjectionSuggestionType, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //


     //submit rest
     async updateObjSuggestionType(data: any) {
     
      return new Promise((resolve) => {
        this.httpClient
          .post(ApiUrls.updateObjectionSuggestionType, data)
          .toPromise()
          .then((res) => {
            resolve(res);
          })
          .catch((resp: Response) => {
            resolve(resp);
          });
      });
    }
    //



     //load Objection and suggestion type rest
  async loadObjectionSuggestionType() {
    const formData = new FormData();
    const url = "";
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadObjectionAndSuggestionType, formData)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //


    //load board rest
    async loadBoard() {
      const url = "loadBoards";
      return new Promise((resolve) => {
        this.httpClient
          .post(ApiUrls.loadBoard, {})
          .toPromise()
          .then((res) => {
            resolve(res);
          })
          .catch((resp: Response) => {
            resolve(resp);
          });
      });
    }
    //


    //load departments type rest
  async loadDepartments(boardId: any) {
    const data = { 'bdId': boardId, };
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadDepartment, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //


    //view signleGrievanceType

    async viewSignleObjSuggestionType(objSuggId) {
      const data={
        'pkOstid':objSuggId
      }
      return new Promise((resolve) => {
        this.httpClient
          .post(ApiUrls.loadOneObjectionAndSuggestionType,data)
          .toPromise()
          .then((res) => {
            resolve(res);
          })
          .catch((resp: Response) => {
            resolve(resp);
          });
      });
    }
    //
    //


    async deleteOSType(data){
      return new Promise((resolve) => {
        this.httpClient
          .post(ApiUrls.deleteObjectionAndSuggestionType,data)
          .toPromise()
          .then((res) => {
            resolve(res);
          })
          .catch((resp: Response) => {
            resolve(resp);
          });
      });
    }
}
